module.exports = __webpack_public_path__ + "img/danger.f6dc0992.svg";